import { trackWithGoogleAnalytics } from '../../../../../../shared/analytics/shared/trackers/trackWithGoogleAnalytics';

export const setLastBookingDateProperty = (lastBookingDate: string) => {
	trackWithGoogleAnalytics('set', 'user_properties', {
		lastBookingDate,
	});
};
